<div *ngIf="show" class="tw-w-full tw-h-fit tw-px-8 tw-mb-5 tw-mt-5">
  <div class="tw-w-full tw-h-fit tw-relative tw-bg-secondary tw-rounded-[5px] tw-z-50 tw-p-5">
    <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white">{{ "no-internet-connection" | translate }}</p>
  </div>
</div>
